import React from 'react';
import type { FC } from 'react';
import { TextMobile as Text } from '@alfa-bank/site-text-v2/mobile';

import type { TBadge } from './models';

export const Badge: FC<TBadge> = ({ styles, text, view }) => (
    <Text className={styles.badge} tag="div" view={view}>
        {text}
    </Text>
);
